module.exports = __webpack_public_path__ + "static/media/wu.391d3f3d.png";